import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
import noZoom from "./assets/js/noZoom";
noZoom();
export default {
  provide() {
    return {
      reload: this.reload
    };
  },
  computed: {
    ...walletVuex.mapState(["tonConnect", "isMobile", "htmlSize"]),
    ...userVuex.mapState(["userInfo", "loginInfo", "isLogin"]),
    route() {
      return this.$route.path;
    },
    isPhone() {
      const sUserAgent = navigator.userAgent.toLowerCase();
      return /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent);
    }
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  watch: {},
  methods: {
    ...userVuex.mapActions(["initProcess", "bindWallet", "getuserInfo"]),
    ...userVuex.mapMutations(["setIsLogin"]),
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  }
};